import FullStarIcon from '@app/assets/icons/star-full.svg?react';
import HalfStarIcon from '@app/assets/icons/star-half.svg?react';
import EmptyStarIcon from '@app/assets/icons/star-empty.svg?react';

interface StarRatingProps {
  rating: number;
  size?: { width: number; height: number };
  className?: string;
}

export const StarRating = ({ rating, size = { width: 16, height: 16 }, className = '' }: StarRatingProps) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;

  // Add full stars
  for (let i = 0; i < fullStars; i++) {
    stars.push(
      <FullStarIcon
        key={`full-${i}`}
        {...size}
        className="text-orange-400"
      />
    );
  }

  // Add half star if needed
  if (hasHalfStar) {
    stars.push(
      <HalfStarIcon
        key="half"
        {...size}
        className="text-orange-400"
      />
    );
  }

  // Add empty stars to complete 5 stars
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  for (let i = 0; i < emptyStars; i++) {
    stars.push(
      <EmptyStarIcon
        key={`empty-${i}`}
        {...size}
        className="text-gray-300"
      />
    );
  }

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {stars}
    </div>
  );
}; 